import { render, staticRenderFns } from "./ConversationAction.vue?vue&type=template&id=0315b656&scoped=true&"
import script from "./ConversationAction.vue?vue&type=script&lang=js&"
export * from "./ConversationAction.vue?vue&type=script&lang=js&"
import style0 from "./ConversationAction.vue?vue&type=style&index=0&id=0315b656&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0315b656",
  null
  
)

export default component.exports